import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=8ddcef36&scoped=true"
import script from "./roleForm.vue?vue&type=script&lang=js"
export * from "./roleForm.vue?vue&type=script&lang=js"
import style0 from "./roleForm.vue?vue&type=style&index=0&id=8ddcef36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddcef36",
  null
  
)

export default component.exports